<template>
  <input
    ref="fileInputRef"
    class="hidden"
    type="file"
    :accept="accept.join(',')"
    :multiple="multiple"
    @change="onChangeInput"
  />
  <slot v-bind="{ browseFile }" />
</template>

<script setup lang="ts">
import { ref, unref } from '@/composition/vue/compositionApi'

const { accept = [] } = defineProps<{
  accept?: string[]
  multiple?: boolean
}>()

const emit = defineEmits<{
  'files-picked': [File[]]
}>()

const fileInputRef = ref()

const browseFile = () => {
  const fileInput = unref(fileInputRef)
  if (!fileInput) {
    return
  }

  fileInput.value = null
  fileInput.click()
}

const onChangeInput = (e: Event) => {
  const files = (e.target as HTMLInputElement).files!
  emit('files-picked', [...files])
}
</script>
